import React, { Component } from "react"
import MetaTags from 'react-meta-tags';
import PropTypes from 'prop-types'
import { connect } from "react-redux"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { withTranslation } from "react-i18next"
import "flatpickr/dist/themes/material_blue.css"
import SettingSidebar from "../../../components/VerticalLayout/SettingSidebar";
import { getUserDetail, updateUserCurrency } from "../../../store/actions"
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  FormGroup,
  Label,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
} from "reactstrap"
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import GeneralSettingMenu from "../menu/general-setting-menu";
import UpdateButton from "components/buttons/updateBtn";
import CurrencyDropdown from "components/dropdowns/Other/CurrencyDropdowns";
import EmailSettingMenu from "../menu/email-setting-menu";
import ActionEdit from "components/buttons/actionEdit";
import SaveButton from "components/buttons/save";
import JoditEditor from 'jodit-react';
import { API_URL } from "helpers/app_url";
import axios from "axios";
import { template } from "lodash";
import RichTextEditor from "components/dropdowns/ContentEditor";
import SafeField from "helpers/SafeField";
class EmailTemplates extends Component {
  constructor(props) {
    super(props)
    this.state = {
      templates: [],
      tags: [],
      loadings: true,
    }
    this.toggleAddNew = this.toggleAddNew.bind(this);
  }
  componentDidMount() {
    const { onGetUserDetail } = this.props;
    onGetUserDetail(localStorage.getItem('userId'));
    this.fetchAllTemplates();
    this.fetchAllTags();
  }

  toggle() {
    this.setState(prevState => ({
      isAddNew: !prevState.isAddNew
    }));
  }
  toggleAddNew() {
    this.setState({ template: "", isEdit: false, isAddNew: !this.state.isAddNew });
    this.toggle();
  }
  toggleAddNew = arg => {
    const template = arg;
    this.setState({
      template: {
        id: template.id,
        templateId: template.templateId,
        templateTitle: template.templateTitle,
        templateFilterTags: template.templateFilterTags,
        templateCategoryId: template.templateCategoryId,
        templateReplacementTag: template.templateReplacementTag,
        templateEmailSubject: template.templateEmailSubject,
        templateEmailBody: template.templateEmailBody,
        templateSMSBody: template.templateSMSBody,
        templateDescription: template.templateDescription,
        templateKeyword: template.templateKeyword,
        agentId: localStorage.getItem('userId'),
        isInternal: template.isInternal,
        isSendEmailEnabled: template.isSendEmailEnabled,
        isSendSMSEnabled: template.isSendSMSEnabled,
        isActive: template.isActive,
      },
      isEdit: true,
    });
    this.toggle();
  }

  fetchAllTags() {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };

    const params = {
      agentId: localStorage.getItem('userId'),

    };
    axios
      .get(`${API_URL}SystemNotificationTag/all`, { headers, params })
      .then((response) => {
        this.setState({ tags: response.data });
      })
      .catch((error) => {
        this.setState({ error: error.message });
      });
  }

  fetchAllTemplates() {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };

    const params = {
      agentId: localStorage.getItem('userId'),

    };
    axios
      .get(`${API_URL}SystemNotificationTemplate/allAgent`, { headers, params })
      .then((response) => {
        this.setState({ templates: response.data, loadings: false });
      })
      .catch((error) => {
        this.setState({ error: error.message, loadings: false });
      });
  }
  handleSubmit = (values) => {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };
    const data = {
      id: values.id,
      templateId: values.templateId,
      templateTitle: values.templateTitle,
      templateFilterTags: values.templateFilterTags,
      templateCategoryId: values.templateCategoryId,
      templateReplacementTag: values.templateReplacementTag,
      templateEmailSubject: values.templateEmailSubject,
      templateEmailBody: values.templateEmailBody,
      templateSMSBody: values.templateSMSBody,
      templateDescription: values.templateDescription,
      templateKeyword: values.templateKeyword,
      agentId: parseInt(localStorage.getItem('userId')),
      isInternal: values.isInternal,
      isSendEmailEnabled: values.isSendEmailEnabled,
      isSendSMSEnabled: values.isSendSMSEnabled,
      isActive: values.isActive,
    };
    toast.loading("Please wait ...");
    axios
      .put(`${API_URL}SystemNotificationTemplate`, data, { headers })
      .then((response) => {
        if (response.data.success) {
          toast.dismiss();
          toast.success("Email template updated successfully");


        } else {
          toast.dismiss();
          toast.error(response.data.validationErrors?.[0] || "An error occurred.");
        }
      })
      .catch((error) => {
        this.setState({ loadings: false });

      }
      );
  }
handleChangetemplateTags = (event) => {
  this.setState({ templateFilterTags: event.target.value });
};
getFilteredTemplates = () => {
  const { templates, templateFilterTags } = this.state;

  if (!templateFilterTags) {
    return templates; 
  }

  return templates.filter(template => {
  if (!template.templateFilterTags) return false;

  const tagIds = template.templateFilterTags
    .split(',')
    .map(tag => Number(tag.trim()));

  return tagIds.includes(parseInt(templateFilterTags));
});
};

getTagTitles = (tagIdsString) => {
  if (!tagIdsString) return [];
  const tagIds = tagIdsString.split(',').map(id => id.trim());
  return this.state.tags
    .filter(tag => tagIds.includes(String(tag.id)))
    .map(tag => tag.systemNotificationTagTitle);
};
  render() {
    const { templates, template } = this.state;
    return (
      <React.Fragment>
        {this.state.loadings && this.state.loadings ? (
          <div className="loading">Loading&#8230;</div>
        ) : null}
        <ToastContainer autoClose={2000} />
        <div className="page-content">
          <MetaTags>
            <title>Email Templates | Realty Space</title>
          </MetaTags>
          <Container fluid>
            <Row className="mb20">
              <Col xl="6">
                <Breadcrumbs
                  title={this.props.t("Agent")}
                  breadcrumbItem={this.props.t("General Settings")}
                />
              </Col>
            </Row>
            <Row>
              <Col xl="3">
                <SettingSidebar />
              </Col>
              <Col xl="9">
                <EmailSettingMenu />
                <Card>
                  <CardBody>
                      <Row className="mb-4">
                                                  
                      <Col sm="2">
                      <select className="form-select select-filter" value={this.state.templateFilterTags} onChange={this.handleChangetemplateTags}>
                            <option value="">All Tags</option>
                          
                            {this.state.tags.map((tag, index) => (
                              <option key={index} value={tag.id}>
                                {tag.systemNotificationTagTitle}
                              </option>
                            ))}
                          
                      </select>
                      </Col>
                      
                                                 
                    
                  </Row>
                    <table className="table table-bordered">
                      <thead className="table-light striped">
                        <tr>
                          <th>Template Name</th>
                          <th>Tags</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.getFilteredTemplates().map((template, index) => (
                          <tr key={index}>
                            <td>{template.templateTitle}
                              <br />

                              <span>Email : {template.isSendEmailEnabled ? 'Active' : 'In-active'} | SMS : {template.isSendSMSEnabled ? 'Active' : 'In-active'}</span>

                            </td>
                            <td>
                              <h5>
                                 {this.getTagTitles(template.templateFilterTags).map((tagTitle, idx) => (
                                <span key={idx} className="badge bg-primary me-1">
                                  {tagTitle}
                                </span>
                              ))}
                              </h5>
                            </td>
                            <td>
                              <div className="d-flex">
                                <ActionEdit onClick={() => this.toggleAddNew(template)} />

                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>



        <Offcanvas
          isOpen={this.state.isAddNew}
          direction="end"
          toggle={this.toggleAddNew}
          style={{ width: 600 }}
        >
          <OffcanvasHeader toggle={this.toggleAddNew}>
            Update Email Template
          </OffcanvasHeader>
          <OffcanvasBody>
            <Formik
              enableReinitialize={true}
              initialValues={{
                id: template?.id,
                templateId: template?.templateId,
                templateTitle: template?.templateTitle,
                templateFilterTags: template?.templateFilterTags,
                templateCategoryId: template?.templateCategoryId,
                templateReplacementTag: template?.templateReplacementTag,
                templateEmailSubject: template?.templateEmailSubject,
                templateEmailBody: template?.templateEmailBody,
                templateSMSBody: template?.templateSMSBody,
                templateDescription: template?.templateDescription,
                templateKeyword: template?.templateKeyword,
                agentId: localStorage.getItem('userId'),
                isInternal: template?.isInternal,
                isSendEmailEnabled: template?.isSendEmailEnabled,
                isSendSMSEnabled: template?.isSendSMSEnabled,
                isActive: template?.isActive,
              }}
              validationSchema={Yup.object().shape({
                //templateTitle: Yup.string().required("This is required"),
                //templateFilterTags: Yup.string().required("This is required")
              })}

              onSubmit={this.handleSubmit}

            >
              {({ errors, touched, values, handleChange, handleBlur, setFieldValue }) => (
                <Form
                  className="needs-validation"
                >


                  <Row>

                    <Col md="12">
                      <FormGroup className="mb-3 d-flex gap-4">
                        <div className="form-check">
                          <SafeField
                            type="checkbox"
                            name="isSendEmailEnabled"
                            className="form-check-input"
                            id="isSendEmailEnabled"
                          />
                          <Label className="form-check-label" htmlFor="isSendEmailEnabled">
                            Active
                          </Label>
                        </div>
                        <div className="form-check">
                          <SafeField
                            type="checkbox"
                            name="isSendSMSEnabled"
                            className="form-check-input"
                            id="isSendSMSEnabled"
                          />
                          <Label className="form-check-label" htmlFor="isSendSMSEnabled">
                            Send SMS
                          </Label>
                        </div>
                      </FormGroup>

                      {/* <FormGroup className="mb-3">
                        <Label htmlFor="templateFilterTags">{this.props.t("Tag")}</Label>
                        <SafeField as="select" name="templateFilterTags" className="form-control">
                          <option value="">Select</option>
                          {this.state.tags.map((tag, index) => (
                            <option key={index} value={tag.id}>
                              {tag.systemNotificationTagTitle}
                            </option>
                          ))}
                        </SafeField>
                        <ErrorMessage name="templateFilterTags" component="div" className="invalid-feedback" />
                      </FormGroup> */}

                      <FormGroup className="mb-3">
                        <Label htmlFor="templateEmailSubject">Email subject*</Label>
                        <SafeField
                          name="templateEmailSubject"
                          className={
                            "form-control" +
                            (errors.templateEmailSubject && touched.templateEmailSubject
                              ? " is-invalid"
                              : "")
                          }
                          onChange={handleChange}
                          type="text"
                        />
                        <ErrorMessage
                          name="templateEmailSubject"
                          component="div"
                          className="invalid-feedback"
                        />
                      </FormGroup>
                      <FormGroup>

                        <Label htmlFor="templateEmailBody">Email body</Label>
                          <RichTextEditor
                          name="templateEmailBody"
                          setFieldValue={setFieldValue}
                          initialContent={values.templateEmailBody}
                          placeholder="Enter email content here..."
                        />
                       
                      </FormGroup>

                      <FormGroup>

                        <Label htmlFor="templateSMSBody">SMS Content</Label>
                        <SafeField
                          name="templateSMSBody"
                          className={
                            "form-control" +
                            (errors.templateSMSBody && touched.templateSMSBody
                              ? " is-invalid"
                              : "")
                          }
                          onChange={handleChange}
                          as="textarea"
                        />
                      </FormGroup>
                    </Col>

                  </Row>






                  <div><SaveButton>Save</SaveButton></div>

                </Form>
              )}
            </Formik>

          </OffcanvasBody>
        </Offcanvas>

      </React.Fragment>
    )
  }
}
EmailTemplates.propTypes = {
  t: PropTypes.any,
  history: PropTypes.object,
  match: PropTypes.object,
  onGetUserDetail: PropTypes.func,
  userdetail: PropTypes.object,
  onUpdateUserCurrency: PropTypes.func
}
const mapStateToProps = ({ Login }) => (
  {
    userdetail: Login.userdetail
  })
const mapDispatchToProps = dispatch => ({
  onGetUserDetail: (agentId) => dispatch(getUserDetail(agentId)),
  onUpdateUserCurrency: (data) => dispatch(updateUserCurrency(data))
});
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(EmailTemplates))
